const baseClasses = {
  Knight: {
    name: "Knight",
    lvl: 13,
    stats: {
      VIGOR: 14,
      ATTUNEMENT: 8,
      ENDURANCE: 12,
      VITALITY: 16,
      STRENGTH: 14,
      DEXTERITY: 14,
      INTELLIGENCE: 8,
      FAITH: 9,
      LUCK: 8,
    },
  },
  Warrior: {
    name: "Warrior",
    lvl: 13,
    stats: {
      VIGOR: 14,
      ATTUNEMENT: 7,
      ENDURANCE: 12,
      VITALITY: 14,
      STRENGTH: 18,
      DEXTERITY: 10,
      INTELLIGENCE: 8,
      FAITH: 9,
      LUCK: 11,
    },
  },
  Thief: {
    name: "Thief",
    lvl: 12,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 10,
      ENDURANCE: 14,
      VITALITY: 10,
      STRENGTH: 10,
      DEXTERITY: 18,
      INTELLIGENCE: 10,
      FAITH: 8,
      LUCK: 12,
    },
  },
  Outcast: {
    name: "Outcast",
    lvl: 13,
    stats: {
      VIGOR: 9,
      ATTUNEMENT: 14,
      ENDURANCE: 9,
      VITALITY: 8,
      STRENGTH: 11,
      DEXTERITY: 12,
      INTELLIGENCE: 16,
      FAITH: 16,
      LUCK: 8,
    },
  },
  Acolyte: {
    name: "Acolyte",
    lvl: 14,
    stats: {
      VIGOR: 12,
      ATTUNEMENT: 10,
      ENDURANCE: 13,
      VITALITY: 5,
      STRENGTH: 12,
      DEXTERITY: 18,
      INTELLIGENCE: 8,
      FAITH: 16,
      LUCK: 10,
    },
  },
  Sorcerer: {
    name: "Sorcerer",
    lvl: 14,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 16,
      ENDURANCE: 12,
      VITALITY: 10,
      STRENGTH: 8,
      DEXTERITY: 10,
      INTELLIGENCE: 20,
      FAITH: 8,
      LUCK: 10,
    },
  },
  Pyromancer: {
    name: "Pyromancer",
    lvl: 14,
    stats: {
      VIGOR: 9,
      ATTUNEMENT: 15,
      ENDURANCE: 10,
      VITALITY: 8,
      STRENGTH: 10,
      DEXTERITY: 10,
      INTELLIGENCE: 16,
      FAITH: 16,
      LUCK: 10,
    },
  },
  Cleric: {
    name: "Cleric",
    lvl: 14,
    stats: {
      VIGOR: 12,
      ATTUNEMENT: 16,
      ENDURANCE: 10,
      VITALITY: 11,
      STRENGTH: 12,
      DEXTERITY: 8,
      INTELLIGENCE: 7,
      FAITH: 20,
      LUCK: 8,
    },
  },
  Deprived: {
    name: "Deprived",
    lvl: 1,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 10,
      ENDURANCE: 10,
      VITALITY: 10,
      STRENGTH: 10,
      DEXTERITY: 10,
      INTELLIGENCE: 10,
      FAITH: 10,
      LUCK: 10,
    },
  },
  Wayfarer: {
    name: "Wayfarer",
    lvl: 14,
    stats: {
      VIGOR: 12,
      ATTUNEMENT: 9,
      ENDURANCE: 12,
      VITALITY: 15,
      STRENGTH: 14,
      DEXTERITY: 18,
      INTELLIGENCE: 8,
      FAITH: 7,
      LUCK: 9,
    },
  },
  Soldier: {
    name: "Soldier",
    lvl: 12,
    stats: {
      VIGOR: 12,
      ATTUNEMENT: 10,
      ENDURANCE: 12,
      VITALITY: 12,
      STRENGTH: 16,
      DEXTERITY: 16,
      INTELLIGENCE: 8,
      FAITH: 9,
      LUCK: 7,
    },
  },
  Sentinel: {
    name: "Sentinel",
    lvl: 16,
    stats: {
      VIGOR: 14,
      ATTUNEMENT: 6,
      ENDURANCE: 13,
      VITALITY: 20,
      STRENGTH: 24,
      DEXTERITY: 10,
      INTELLIGENCE: 8,
      FAITH: 6,
      LUCK: 5,
    },
  },
  Mercenary: {
    name: "Mercenary",
    lvl: 12,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 8,
      ENDURANCE: 12,
      VITALITY: 14,
      STRENGTH: 12,
      DEXTERITY: 18,
      INTELLIGENCE: 8,
      FAITH: 9,
      LUCK: 11,
    },
  },
  Assassin: {
    name: "Assassin",
    lvl: 11,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 14,
      ENDURANCE: 13,
      VITALITY: 9,
      STRENGTH: 8,
      DEXTERITY: 13,
      INTELLIGENCE: 18,
      FAITH: 6,
      LUCK: 10,
    },
  },
  Samurai: {
    name: "Samurai",
    lvl: 18,
    stats: {
      VIGOR: 13,
      ATTUNEMENT: 8,
      ENDURANCE: 12,
      VITALITY: 17,
      STRENGTH: 14,
      DEXTERITY: 18,
      INTELLIGENCE: 7,
      FAITH: 9,
      LUCK: 10,
    },
  },
  Bandit: {
    name: "Bandit",
    lvl: 16,
    stats: {
      VIGOR: 14,
      ATTUNEMENT: 10,
      ENDURANCE: 12,
      VITALITY: 15,
      STRENGTH: 20,
      DEXTERITY: 10,
      INTELLIGENCE: 8,
      FAITH: 9,
      LUCK: 8,
    },
  },
  Paladin: {
    name: "Paladin",
    lvl: 18,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 10,
      ENDURANCE: 8,
      VITALITY: 26,
      STRENGTH: 28,
      DEXTERITY: 7,
      INTELLIGENCE: 4,
      FAITH: 12,
      LUCK: 5,
    },
  },
  Herald: {
    name: "Herald",
    lvl: 11,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 10,
      ENDURANCE: 8,
      VITALITY: 16,
      STRENGTH: 13,
      DEXTERITY: 16,
      INTELLIGENCE: 7,
      FAITH: 15,
      LUCK: 6,
    },
  },
  Captain: {
    name: "Captain",
    lvl: 15,
    stats: {
      VIGOR: 14,
      ATTUNEMENT: 10,
      ENDURANCE: 10,
      VITALITY: 18,
      STRENGTH: 17,
      DEXTERITY: 14,
      INTELLIGENCE: 8,
      FAITH: 6,
      LUCK: 10,
    },
  },
  Peasant: {
    name: "Peasant",
    lvl: 12,
    stats: {
      VIGOR: 13,
      ATTUNEMENT: 8,
      ENDURANCE: 12,
      VITALITY: 8,
      STRENGTH: 10,
      DEXTERITY: 16,
      INTELLIGENCE: 8,
      FAITH: 8,
      LUCK: 19,
    },
  },
  Explorer: {
    name: "Explorer",
    lvl: 18,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 7,
      ENDURANCE: 10,
      VITALITY: 13,
      STRENGTH: 12,
      DEXTERITY: 18,
      INTELLIGENCE: 10,
      FAITH: 10,
      LUCK: 18,
    },
  },
  Brawler: {
    name: "Brawler",
    lvl: 15,
    stats: {
      VIGOR: 15,
      ATTUNEMENT: 10,
      ENDURANCE: 15,
      VITALITY: 10,
      STRENGTH: 15,
      DEXTERITY: 15,
      INTELLIGENCE: 7,
      FAITH: 8,
      LUCK: 10,
    },
  },
  Hunter: {
    name: "Hunter",
    lvl: 16,
    stats: {
      VIGOR: 10,
      ATTUNEMENT: 10,
      ENDURANCE: 14,
      VITALITY: 8,
      STRENGTH: 10,
      DEXTERITY: 24,
      INTELLIGENCE: 11,
      FAITH: 10,
      LUCK: 9,
    },
  },
  Priest: {
    name: "Priest",
    lvl: 16,
    stats: {
      VIGOR: 9,
      ATTUNEMENT: 16,
      ENDURANCE: 12,
      VITALITY: 9,
      STRENGTH: 12,
      DEXTERITY: 12,
      INTELLIGENCE: 8,
      FAITH: 20,
      LUCK: 8,
    },
  },
  Heretic: {
    name: "Heretic",
    lvl: 12,
    stats: {
      VIGOR: 9,
      ATTUNEMENT: 15,
      ENDURANCE: 10,
      VITALITY: 8,
      STRENGTH: 10,
      DEXTERITY: 11,
      INTELLIGENCE: 17,
      FAITH: 14,
      LUCK: 8,
    },
  },
  Skeptic: {
    name: "Skeptic",
    lvl: 17,
    stats: {
      VIGOR: 8,
      ATTUNEMENT: 15,
      ENDURANCE: 10,
      VITALITY: 10,
      STRENGTH: 12,
      DEXTERITY: 11,
      INTELLIGENCE: 14,
      FAITH: 17,
      LUCK: 10,
    },
  },
  Accursed: {
    name: "Accursed",
    lvl: 1,
    stats: {
      VIGOR: 0,
      ATTUNEMENT: 0,
      ENDURANCE: 0,
      VITALITY: 0,
      STRENGTH: 0,
      DEXTERITY: 0,
      INTELLIGENCE: 0,
      FAITH: 0,
      LUCK: 0,
    },
  },
};

export default baseClasses;
